export function isDevelopment() {
  return import.meta.env?.MODE === "development";
}

export function minMax(value: number, min: number, max: number) {
  return Math.min(Math.max(value, min), max);
}

export function randomArrayElement<T>(array: T[]) {
  return array[Math.floor(Math.random() * array.length)];
}

export function randomBackToTheFutureName() {
  const names = [
    "Marty McFly",
    "Dr. Emmett",
    "Jennifer Parker",
    "George McFly",
    "Lorraine Baines",
    "Biff Tannen",
    "Buford 'Mad Dog' Tannen",
    "Clara Clayton",
    "Einstein",
    "Needles",
    "Marvin Berry",
    "Goldie Wilson",
    "Doc Brown",
  ];

  return randomArrayElement(names);
}
